export const eskisehirCenter = {
  lat: 39.7767,
  lng: 30.5206
};

export const mockSponsors = [
  {
    id: 1,
    name: "sponsor 1",
    description: "açıklama 1",
    category: "Kafe",
    discountInfo: "MACS üyelerine %15 indirim",
    is_featured: true,
    imageUrl: null,
    location: {
      address: "Eskişehir Teknopark, No: 15",
      lat: 39.7850,
      lng: 30.5100
    }
  },
  {
    id: 2,
    name: "sponsor 2",
    description: "açıklama 2",
    category: "Restoran",
    discountInfo: "Öğrenci kartı ile %10 indirim",
    is_featured: true,
    imageUrl: null,
    location: {
      address: "Odunpazarı, Merkez Mah.",
      lat: 39.7700,
      lng: 30.5250
    }
  },
  {
    id: 3,
    name: "sponsor 3",
    description: "açıklama 3",
    category: "Teknoloji",
    discountInfo: "Tüm ürünlerde %20 indirim",
    imageUrl: null,
    location: {
      address: "Tepebaşı, İş Merkezi Kat: 5",
      lat: 39.7800,
      lng: 30.5300
    }
  },
  {
    id: 4,
    name: "sponsor 4",
    description: "açıklama 4",
    category: "Eğitim",
    discountInfo: "İlk ay ücretsiz deneme",
    imageUrl: null,
    location: {
      address: "Eskişehir OSB, B Blok",
      lat: 39.7600,
      lng: 30.4900
    }
  },
  {
    id: 5,
    name: "sponsor 5",
    description: "açıklama 5",
    category: "Spor",
    discountInfo: "Aylık üyelikte %25 indirim",
    imageUrl: null,
    location: {
      address: "Üniversite Mah., Bilim Sok. No: 8",
      lat: 39.7900,
      lng: 30.5150
    }
  },
  {
    id: 6,
    name: "sponsor 6",
    description: "açıklama 6",
    category: "Kafe",
    discountInfo: "Her kahvede 2. bardak bedava",
    imageUrl: null,
    location: {
      address: "Bağlar Cad. No: 42",
      lat: 39.7750,
      lng: 30.5350
    }
  }
];
